import {
  extractWindow,
  extractPct,
  normalizeAlert,
  typeKeyToUpper,
  TYPE_EMOJI,
} from "./alerts_normalize";
import { normalizeWindowKey, toWindowLabel } from "./windows.js";

export { extractWindow, extractPct };

const asNum = (v) => {
  if (v === null || v === undefined) return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

// Prefer typed metrics.pct, then top-level pct.
export const extractAlertPct = (a = {}) => {
  const metricsPct = asNum(a?.metrics?.pct);
  if (metricsPct !== null) {
    return {
      pct: metricsPct,
      window_s: asNum(a?.metrics?.window_s),
      fromMetrics: true,
    };
  }

  const topPct = asNum(a?.pct);
  if (topPct !== null) {
    return {
      pct: topPct,
      window_s: asNum(a?.window_s),
      fromMetrics: false,
    };
  }

  return {
    pct: null,
    window_s: null,
    fromMetrics: false,
  };
};

export const windowLabelFromType = (raw) => {
  const key = normalizeWindowKey(extractWindow(raw), { type: raw });
  return toWindowLabel(key);
};

export const parseImpulseMessage = (a) => {
  const msg = String(a?.message || "");
  const title = String(a?.title || "");
  const parsed_pct =
    typeof a?.pct === "number" && Number.isFinite(a.pct)
      ? a.pct
      : extractPct(msg) ?? extractPct(title);

  const parsedWindowRaw =
    String(a?.window || "").toLowerCase() ||
    windowLabelFromType(a?.type) ||
    extractWindow(msg) ||
    extractWindow(title) ||
    "";
  const parsed_window_label = toWindowLabel(
    normalizeWindowKey(parsedWindowRaw, { type: a?.type })
  );

  const directionRaw = String(a?.direction || "").toLowerCase();
  let parsed_direction = null;

  if (["up", "down", "flat"].includes(directionRaw)) {
    parsed_direction = directionRaw;
  } else if (Number.isFinite(parsed_pct)) {
    parsed_direction = parsed_pct > 0 ? "up" : parsed_pct < 0 ? "down" : "flat";
  }

  return {
    parsed_pct: Number.isFinite(parsed_pct) ? parsed_pct : null,
    parsed_window_label,
    parsed_direction: parsed_direction || "flat",
  };
};

export const ALERT_TYPE_LABELS = {
  MOONSHOT: `${TYPE_EMOJI.moonshot} MOONSHOT`,
  CRATER: `${TYPE_EMOJI.crater} CRATER`,
  BREAKOUT: `${TYPE_EMOJI.breakout} BREAKOUT`,
  DUMP: `${TYPE_EMOJI.dump} DUMP`,
  MOVE: `${TYPE_EMOJI.move} MOVE`,
  WHALE: `${TYPE_EMOJI.whale} WHALE`,
  STEALTH: `${TYPE_EMOJI.stealth} STEALTH`,
  DIVERGENCE: `${TYPE_EMOJI.divergence} DIVERGENCE`,
  FOMO: `${TYPE_EMOJI.fomo} FOMO`,
  FEAR: `${TYPE_EMOJI.fear} FEAR`,
  VOLUME: `${TYPE_EMOJI.volume} VOLUME`,
  SENTIMENT: `${TYPE_EMOJI.sentiment} SENTIMENT`,
  ALERT: `${TYPE_EMOJI.unknown} ALERT`,
};

export const getAlertTypeLabel = (alertType) => {
  const key = String(alertType || "").toUpperCase();
  return ALERT_TYPE_LABELS[key] || ALERT_TYPE_LABELS.ALERT;
};

export const deriveAlertType = ({ type, pct, severity, window, message, title } = {}) => {
  const norm = normalizeAlert({ type, pct, severity, window, message, title });
  return typeKeyToUpper(norm.type_key);
};
